import { useState, type ReactNode } from "react";
import type { TrafficLight } from "../api/types";

const BADGE_TEXT: Record<TrafficLight, string> = { green: "OK", yellow: "Behind", red: "Issues", unknown: "?" };

export default function EnvGroupSection({
    label,
    status,
    count,
    children,
}: {
    label: string;
    status: TrafficLight;
    count: number;
    children: ReactNode;
}) {
    const [open, setOpen] = useState(true);
    return (
        <section className="env-section">
            <div className="env-header" onClick={() => setOpen((o) => !o)}>
                <h2>
                    <span className={`arrow ${open ? "open" : ""}`}>▶</span>
                    <span className={`env-badge ${status}`}>{BADGE_TEXT[status]}</span>
                    {label}
                    <span className="env-count">
                        {count} cluster{count === 1 ? "" : "s"}
                    </span>
                </h2>
            </div>
            {open ? <div className="env-body">{children}</div> : null}
        </section>
    );
}
